// import variables from '!!sass-variable-loader!styles/libs/_variables.scss'
import mq from 'styles/libs/_mq.scss'

const style = Object.assign({}, mq)
// const style = Object.assign({}, variables, mq)

export default style
